import React, { Component } from 'react';

import PageHero from '../components/molecules/PageHero/PageHero'
import FeaturedPoster from '../components/molecules/FeaturedPoster/FeaturedPoster'
import ContentPoster from '../components/molecules/ContentPoster/ContentPoster'
import EventPoster from '../components/molecules/EventPoster/EventPoster'
import CollageBanner from '../components/molecules/CollageBanner/CollageBanner'
import QuoteHero from '../components/molecules/QuoteHero/QuoteHero'

export const renderCmsModule = cmsModule => {
  console.log(`rendering cms module: ${cmsModule.moduleType}`);
  
  switch (cmsModule.moduleType) {
    case `pageHero`:
      return (
        <PageHero
          config={cmsModule}
          content={cmsModule}
        />
      );
    case `featuredPoster`:
      return (
        <FeaturedPoster
          config={cmsModule}
          content={cmsModule}
        />
      );
    case `eventPoster`:
      return (
        <EventPoster
          config={cmsModule}
          content={cmsModule}
        />
      );
    case `collageBanner`:
      return (
        <CollageBanner
          config={cmsModule}
          content={cmsModule}
        />
      );
    case `contentPoster`:
      console.log(`>>>>>>>>>>>> render contentPoster`);
      return (
        <ContentPoster
          config={cmsModule}
          content={cmsModule}
        />
      );
    case `quoteHero`:
      return (
        <QuoteHero
          config={cmsModule}
          content={cmsModule}
        />
      );
    default:
      console.log(`>>>>>>>>>>>>>>>>> CMS MODULE RENDERER SOFT ERROR >>>>>>>>>>>>>>>>>>>>`);
      console.log(`A module with type: ${cmsModule.moduleType} was attempted to be rendered.`);
      console.log(`>>>>>>>>>>>>>>>>> CMS MODULE RENDERER SOFT ERROR >>>>>>>>>>>>>>>>>>>>`);
  };
};